export default __webpack_public_path__ + "b0679506a0753bddad185cf7eb7cc25c.png";